import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE06002S = () => {
  const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태

  return (
    <CommonLayout>
      <CommonMenu />

      <div id="contents" className="container">

        <div className="sub-title bg-type06">
          <h2>인재 채용</h2>
        </div>

        <div className="location_wrap"
          onClick={() => setIsDepthOpen(!isDepthOpen)}>
          <ul className="depth1">
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>복리후생<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE06001S">인재상</Link></li>
                <li><Link to="/GNBPURE06002S">복리후생</Link></li>
                <li><Link to="/GNBPURE06003S">채용공고</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="cont" className="cont">
          <div className="inner">
            
            <h3>복리후생</h3>
            <div className="welfare-container">
              <div className="welfare-grid">

                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_card.png" alt="개인법인카드 지급"/>
                  </div>
                  <div className="text-wrap">
                    <h4>개인법인카드 지급</h4>
                    <p>업무 몰입을 위해 개인 법인카드 한도를 지원합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_airplane.png" alt="해외워크샵"/>
                  </div>
                  <div className="text-wrap">
                    <h4>해외워크샵</h4>
                    <p>팀워크 강화와 재충전을 위한 해외 워크샵을 지원합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_stethoscope.png" alt="종합건강검진 지원"/>
                  </div>
                  <div className="text-wrap">
                    <h4>종합건강검진 지원</h4>
                    <p>임직원 및 가족의 건강 관리를 위해 정기 건강검진을 실시합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_smartphone.png" alt="통신비 지원"/>
                  </div>
                  <div className="text-wrap">
                    <h4>통신비 지원</h4>
                    <p>업무 소통에 필요한 휴대폰 사용비의 일부를 지원합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_reward2.png" alt="운영수당"/>
                  </div>
                  <div className="text-wrap">
                    <h4>운영수당</h4>
                    <p>시스템 운영 및 유지 관리를 위한 수당을 지급합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_reward3.png" alt="프로젝트 인센티브"/>
                  </div>
                  <div className="text-wrap">
                    <h4>프로젝트 인센티브</h4>
                    <p>프로젝트 성공 시 참여 인원에게 성과급 형태의 인센티브를 제공합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_reward1.png" alt="프로젝트 비용 및 운영인력 비용"/>
                  </div>
                  <div className="text-wrap">
                    <h4>프로젝트 비용 및 운영인력 비용</h4>
                    <p>프로젝트 진행에 필요한 비용 및 인력 운영비를 지원합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img//recruit/icon_gift.png" alt="명절상여금"/>
                  </div>
                  <div className="text-wrap">
                    <h4>명절상여금</h4>
                    <p>풍성한 명절을 보낼 수 있도록 설과 추석에 명절 상여금을 지급합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_certificate.png" alt="자격증 취득 수당"/>
                  </div>
                  <div className="text-wrap">
                    <h4>자격증 취득 수당</h4>
                    <p>직무 역량 강화를 위해 자격증 취득 시 수당을 지원합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_prime.png" alt="우수 직원 포상"/>
                  </div>
                  <div className="text-wrap">
                    <h4>우수 직원 포상</h4>
                    <p>탁월한 성과를 보인 직원을 포상하여 동기 부여를 강화합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_recommendation.png" alt="직원추천제도"/>
                  </div>
                  <div className="text-wrap">
                    <h4>직원추천제도</h4>
                    <p>우수 인재를 추천하면 포상 및 채용 연계 기회를 제공합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_envelope.png" alt="경조금 지원"/>
                  </div>
                  <div className="text-wrap">
                    <h4>경조금 지원</h4>
                    <p>결혼, 상조  집안 경조사 발생시 경조금을 지급합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_condo.png" alt="휴양소 지원"/>
                  </div>
                  <div className="text-wrap">
                    <h4>휴양소 지원</h4>
                    <p>휴식과 재충전을 위한 휴양소 이용을 지원합니다.</p>
                  </div>
                </div>
                <div className="welfare-item">
                  <div className="icon-wrap">
                    <img src="/asset/img/recruit/icon_trasportation.png" alt="교통비 지원"/>
                  </div>
                  <div className="text-wrap">
                    <h4>교통비 지원</h4>
                    <p>격지 근무 시 발생하는 교통비를 지원합니다.</p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE06002S;